export enum TabSelectedEnum {
	lead = 'Lead',
	rematricula = 'Rematricula',
	inadimplente = 'Inadimplentes',
}